"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _image = _interopRequireDefault(require("./image"));
var _inspiration = _interopRequireDefault(require("./inspiration"));
var _collection = _interopRequireDefault(require("./collection"));
var _tiles = _interopRequireDefault(require("./tiles"));
var _types = _interopRequireDefault(require("./types"));
var _instagramTiles = _interopRequireDefault(require("./instagramTiles"));
var _seo = _interopRequireDefault(require("./seo"));
var _banner = _interopRequireDefault(require("./banner"));
var _article = _interopRequireDefault(require("./article"));
var _deals = _interopRequireDefault(require("./deals"));
var _inspirationPage = _interopRequireDefault(require("./inspirationPage"));
var _fullImage = _interopRequireDefault(require("./fullImage"));
var mapBlockResponse = function mapBlockResponse(response) {
  var _instagramLink, _response$data, _response$data2, _response$data3, _response$data3$categ, _response$data4, _response$data5, _response$data5$categ, _response$data6, _response$data7, _logoSlice$, _response$data$bestse, _response$data8, _response$data$newpro, _response$data9, _response$data0, _response$data1, _response$data1$promo, _response$data10, _response$data11, _response$data11$prom, _response$data12, _response$data12$prom, _response$data12$prom2, _response$data13, _response$data14, _response$data15;
  if (!response) return;
  var findSliceByType = function findSliceByType(sliceName) {
    return response.data.body && response.data.body.filter(function (item) {
      return item.slice_type === sliceName;
    });
  };
  var blogger = response.data.blogger && response.data.blogger.id;
  var inspirationSlice = findSliceByType("inspiration");
  var inspirations = [];
  inspirationSlice && inspirationSlice.length > 0 && (inspirationSlice === null || inspirationSlice === void 0 ? void 0 : inspirationSlice.map(function (inspiration) {
    inspirations.push((0, _inspiration["default"])(inspiration));
  }));
  var collectionsSlice = findSliceByType("collection");
  var collections = [];
  collectionsSlice && collectionsSlice.length > 0 && (collectionsSlice === null || collectionsSlice === void 0 ? void 0 : collectionsSlice.map(function (collection) {
    collections.push((0, _collection["default"])(collection));
  }));
  var instagramTiles = (0, _instagramTiles["default"])(findSliceByType("instagramtiles"));
  var instagramLink = findSliceByType("instagramlink");
  instagramLink = ((_instagramLink = instagramLink) === null || _instagramLink === void 0 ? void 0 : _instagramLink.length) > 0 ? instagramLink[0].primary.link.url : "https://www.instagram.com/dajar.pl/";
  var collageBannerSlice = findSliceByType("collagebanner");
  var basicBannerSlice = findSliceByType("basicbanner");
  var fullImageSlice = findSliceByType("full_img");
  var collageBanners = (0, _banner["default"])(collageBannerSlice);
  var basicBanners = (0, _banner["default"])(basicBannerSlice);
  var fullImageBanners = (0, _fullImage["default"])(fullImageSlice);
  var tiles = (0, _tiles["default"])(findSliceByType("tiles"));
  var types = (0, _types["default"])(findSliceByType("types"));
  var seo = (0, _seo["default"])(findSliceByType("seo"));
  var inspirationPage = (0, _inspirationPage["default"])(findSliceByType("inspirationpage"), ((_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.blogger) && response.data.blogger.id);
  var article = (_response$data2 = response.data) !== null && _response$data2 !== void 0 && _response$data2.body ? (0, _article["default"])(response.data) : false;
  var deals = (0, _deals["default"])(findSliceByType("deals"));
  var descriptionSlice = findSliceByType("description");
  var description = descriptionSlice && descriptionSlice.length > 0 ? {
    content: descriptionSlice[0].primary.text
  } : null;
  var categoryName = ((_response$data3 = response.data) === null || _response$data3 === void 0 ? void 0 : (_response$data3$categ = _response$data3.category_name) === null || _response$data3$categ === void 0 ? void 0 : _response$data3$categ.length) > 0 && ((_response$data4 = response.data) === null || _response$data4 === void 0 ? void 0 : _response$data4.category_name[0].text);
  var categoryDescription = ((_response$data5 = response.data) === null || _response$data5 === void 0 ? void 0 : (_response$data5$categ = _response$data5.category_description) === null || _response$data5$categ === void 0 ? void 0 : _response$data5$categ.length) > 0 && ((_response$data6 = response.data) === null || _response$data6 === void 0 ? void 0 : _response$data6.category_description[0].text);
  var newsletterBackgroundSlice = findSliceByType("newsletter_bg");
  var newsletterBackground = (newsletterBackgroundSlice === null || newsletterBackgroundSlice === void 0 ? void 0 : newsletterBackgroundSlice.length) > 0 && (0, _image["default"])(newsletterBackgroundSlice[0].primary.image);
  var popularSearches = (response === null || response === void 0 ? void 0 : response.type) === "popularsearches" && ((_response$data7 = response.data) === null || _response$data7 === void 0 ? void 0 : _response$data7.links.map(function (link) {
    var _link$title, _link$link, _link$link$url;
    return ((_link$title = link.title) === null || _link$title === void 0 ? void 0 : _link$title.length) > 0 ? {
      url: (_link$link = link.link) === null || _link$link === void 0 ? void 0 : (_link$link$url = _link$link.url) === null || _link$link$url === void 0 ? void 0 : _link$link$url.replace("https://", ""),
      title: link.title[0].text
    } : null;
  }));
  var logoSlice = findSliceByType("logo");
  var logo = logoSlice ? (0, _image["default"])((_logoSlice$ = logoSlice[0]) === null || _logoSlice$ === void 0 ? void 0 : _logoSlice$.primary.image) : false;
  var bestsellers = (_response$data$bestse = (_response$data8 = response.data) === null || _response$data8 === void 0 ? void 0 : _response$data8.bestsellers) !== null && _response$data$bestse !== void 0 ? _response$data$bestse : "";
  var newProducts = (_response$data$newpro = (_response$data9 = response.data) === null || _response$data9 === void 0 ? void 0 : _response$data9.newproducts) !== null && _response$data$newpro !== void 0 ? _response$data$newpro : "";
  Array.isArray(response.linkedContentResponse) && response.linkedContentResponse.map(function (element) {
    if (element.slice_type === "inspiration") {
      inspirations.push((0, _inspiration["default"])(element));
    }
  });
  var categoryBanner = (_response$data0 = response.data) !== null && _response$data0 !== void 0 && _response$data0.category_banner ? (0, _image["default"])(response.data.category_banner) : null;
  var promoBanner = ((_response$data1 = response.data) === null || _response$data1 === void 0 ? void 0 : (_response$data1$promo = _response$data1.promobanner) === null || _response$data1$promo === void 0 ? void 0 : _response$data1$promo.url) === undefined ? null : {
    url: (_response$data10 = response.data) !== null && _response$data10 !== void 0 && _response$data10.is_url_external ? (_response$data11 = response.data) === null || _response$data11 === void 0 ? void 0 : (_response$data11$prom = _response$data11.promobanner_url) === null || _response$data11$prom === void 0 ? void 0 : _response$data11$prom.url : (_response$data12 = response.data) === null || _response$data12 === void 0 ? void 0 : (_response$data12$prom = _response$data12.promobanner_url) === null || _response$data12$prom === void 0 ? void 0 : (_response$data12$prom2 = _response$data12$prom.url) === null || _response$data12$prom2 === void 0 ? void 0 : _response$data12$prom2.replace("https:/", ""),
    image: (_response$data13 = response.data) !== null && _response$data13 !== void 0 && _response$data13.promobanner ? (0, _image["default"])((_response$data14 = response.data) === null || _response$data14 === void 0 ? void 0 : _response$data14.promobanner) : null
  };
  return {
    url: response.uid,
    headerLightMode: (_response$data15 = response.data) === null || _response$data15 === void 0 ? void 0 : _response$data15.header_light_mode,
    logo: logo,
    inspirations: inspirations,
    collections: collections,
    instagramTiles: instagramTiles,
    categoryName: categoryName,
    categoryDescription: categoryDescription,
    instagramLink: instagramLink,
    collageBanners: collageBanners,
    basicBanners: basicBanners,
    fullImageBanners: fullImageBanners,
    article: article,
    tiles: tiles,
    types: types,
    popularSearches: popularSearches,
    description: description,
    deals: deals,
    blogger: blogger,
    inspirationPage: inspirationPage,
    newsletterBackground: newsletterBackground,
    seo: seo,
    bestsellers: bestsellers,
    newProducts: newProducts,
    categoryBanner: categoryBanner,
    promoBanner: promoBanner
  };
};
var _default = mapBlockResponse;
exports["default"] = _default;